const data = Object.freeze({
  PlanningNextSchoolYear: 1,
  AssignStudent: 2,
  DeterioratedBook: 3,
  LostBook: 4,
});
export default data;
